import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {HlrContextService} from '../../services/hlr-context.service';

const SELECT_HLR_CONTEXT_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectHlrContextComponent)
};

@Component({
    selector: 'app-select-hlr-context',
    template: `
      <ngx-select [items]="contexts" [(ngModel)]="context" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" allowClear="true">
          <ng-template ngx-select-option let-option let-text="text">
              {{ option.data.name }} <br />
              <small>Locution label: <strong>{{option.data.loc_label}}</strong> -- Caller id label: <strong>{{ option.data.caller_id_label }}</strong></small><br />
              <small>Caller ID: <strong>{{option.data.caller_id}}</strong> </small>
          </ng-template>
          <ng-template ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }}
          </ng-template>
      </ngx-select>
      `,
    styleUrls: ['./select-hlr-context.component.scss'],
    providers: [SELECT_HLR_CONTEXT_VALUE_ACCESSOR]
})
export class SelectHlrContextComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';

    contexts: Object;
    _context: number;

    constructor(private hlrContextHandler: HlrContextService) { }

    selected(value: any) {
        this.propagateChange(this._context);
    }


    get context(): any { return this._context; };

    set context(v: any) {

        this._context = v;
        this.propagateChange(this._context);
    }

    propagateChange = (_: any) => {};
    onTouched = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(value: any): void {
        this._context = value;
    }

    ngOnInit() {
        this.hlrContextHandler.getContexts().subscribe(
            (result) => {
                this.contexts = result;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/hlr/components/select-hlr-context/select-hlr-context.component.ts